import { Spinner } from '@nextui-org/react';
import { useLoaderStore } from '../../store/use-loader-store';

export const GlobalSpinner = () => {
  const isLoading = useLoaderStore((state) => state.isLoading);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/50">
      <Spinner size="lg" color="primary" />
    </div>
  );
};
